import { camelize } from '@ember/string';
import { filterSystemAndCurrentUser, matchingUsers } from './user';

export const findConversationByContacts = function (conversations, contacts) {
  return conversations.find(conversation => conversationHasExactContacts(conversation, contacts));
};

export const conversationHasExactContacts = function (conversation, contacts) {
  const lengthMatch = conversation.users.length === contacts.length + 1; // +1 for current user
  return (
    lengthMatch &&
    contacts.every(contact => conversation.users.find(u => matchingUsers(u, contact)))
  );
};

export const buildContacts = function (conversation, currentProfile) {
  return filterSystemAndCurrentUser(conversation.users, currentProfile?.user).map(user => {
    return {
      type: 'contacts',
      attributes: {
        'external_id': user.externalId,
        'external_scope': user.externalScope,
        'organization_id': user.organizationId,
        'name': user.name,
      },
    };
  });
};

export async function getInactiveReasonsFromResponse(response) {
  const json = await response.json();
  const error = json.errors?.[0];
  return error?.meta ? camelizeMeta(error?.meta) : fallbackInactiveReason(error?.title);
}

function fallbackInactiveReason(title) {
  return [{ message: title || 'Unknown error' }];
}

function camelizeMeta(inactiveReasons) {
  return inactiveReasons.map(inactiveReason => {
    if (!inactiveReason.meta) return inactiveReason;
    const camelizedMeta = Object.entries(inactiveReason.meta).reduce((acc, [key, value]) => {
      return {
        ...acc,
        ...{ [camelize(key)]: value },
      };
    }, {});
    return { ...inactiveReason, meta: camelizedMeta };
  });
}
